<template>
	<div>
		<template v-if="!renderCell">
			<template v-if="componenttype == 'date'">
				<el-date-picker range-separator="至" v-model="date" v-bind="$props"
					:picker-options="type!='month'?pickerOptions:{}">
				</el-date-picker>
			</template>
			<template v-else>
				<el-time-picker v-model="date" v-bind="$props">
				</el-time-picker>
			</template>
		</template>
		<template v-else>
			<span>{{timestampToDate}}</span>
		</template>
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			componenttype: {
				default: () => {
					return 'date'
				}
			},
			type: {
				default: () => {
					return 'daterange'
				}
			},
			size: {
				default: () => {
					return 'mini'
				}
			},
			format: {
				default: () => {
					return null
				}
			},
			valueFormat: {
				default: () => {
					return 'timestamp'
				}
			},
			prefixIcon: {
				default: () => {
					return 'none'
				}
			},
			unlinkPanels: {
				default: () => {
					return true
				}
			},
			sequence: {
				default: () => {
					return true
				}
			},
			shortcuts: {
				default: () => {
					return [{
							text: '今天',
							code: 'today'
						},
						{
							text: '昨天',
							code: 'day1'
						},
						{
							text: '近3天',
							code: 'day3'
						},
						{
							text: '近7天',
							code: 'day7'
						},
						{
							text: '近30天',
							code: 'day30'
						},
						{
							text: '上月',
							code: 'month1'
						}
					]
				}
			},
		},
		data() {
			return {
				date: this.value,
				pickerOptions: {}
			}
		},
		created() {


		},
		mounted() {
			if (this.type == 'datetimerange' || this.type == 'daterange') {
				if (this.shortcuts.length) {
					let shortcuts = []
					this.shortcuts.forEach((item) => {
						shortcuts.push({
							text: item.text,
							onClick: this[item.code]
						})
					})
					this.pickerOptions = {
						shortcuts: shortcuts
					}
				}
			}
		},
		watch: {
			date(v) {
				this.change(v)
			},
			value(v) {
				this.date = v
			}
		},
		computed: {
			timestampToDate() {
				if (this.componenttype == 'date') {
					return window.systemMethods.timestampToDate(this.value, this.type)
				} else {
					return window.systemMethods.timestampToDate(this.value, 'time')
				}

			}
		},
		methods: {
			// setDate(){

			// 	this.date = this.value
			// 	if (this.row) {
			// 		if (this.row[this.column.field]) {
			// 			this.date = this.row[this.column.field]
			// 		} else {
			// 			this.date = isNaN(parseFloat(this.value)) ? 0 : parseFloat(this.value)
			// 		}
			// 	}
			// },
			today(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time, time + 3600 * 1000 * 24])
					} else {
						picker.$emit('pick', [time, time])
					}
				} else {
					picker.$emit('pick', new Date())
				}
			},
			day1(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time - 3600 * 1000 * 24, time])
					} else {
						picker.$emit('pick', [time - 3600 * 1000 * 24, time - 3600 * 1000 * 24])
					}

				} else {
					picker.$emit('pick', new Date() - 3600 * 1000 * 24)
				}
			},
			day3(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 2, time + 3600 * 1000 * 24])
					} else {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 2, time])
					}

				} else {
					picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 2)
				}
			},
			day7(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 6, time + 3600 * 1000 * 24])
					} else {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 6, time])
					}

				} else {
					picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 6)
				}
			},
			day7_15(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 14, time - 3600 * 1000 * 24 * 6])
					} else {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 6 * 14, time - 3600 * 1000 * 24 * 6])
					}

				} else {
					picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 6 * 14)
				}
			},
			day15_30(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 29, time - 3600 * 1000 * 24 * 14])
					} else {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 6 * 29, time - 3600 * 1000 * 24 * 14])
					}

				} else {
					picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 6 * 29)
				}
			},
			day30(picker) {
				let time = new Date()
				time.setHours(0, 0, 0, 0)
				time = time.getTime()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 29, time + 3600 * 1000 * 24])
					} else {
						picker.$emit('pick', [time - 3600 * 1000 * 24 * 29, time])
					}

				} else {
					picker.$emit('pick', new Date() - 3600 * 1000 * 24 * 29)
				}
			},
			month1(picker) {
				let begin = this.$Moment().subtract(1, 'month').startOf('month').valueOf()
				let end = this.$Moment().subtract(1, 'month').endOf('month').valueOf()
				if (this.type == 'datetimerange' || this.type == 'daterange') {
					if (this.sequence) {
						picker.$emit('pick', [begin, end])
					} else {
						picker.$emit('pick', [begin, end])
					}

				} else {
					picker.$emit('pick', begin)
				}
			}
		}
	}
</script>